export const ACCOUNT_ELAMA_GLOBAL = 'https://account.elama.global/'

export const TERM_LINK_SEARCH = 'https://elama.ru/legal_docs/event/promo-compaign.pdf'
export const TERM_LINK_NETWORK = 'https://elama.ru/legal_docs/event/promo-compaign-gdn.pdf'
export const TERM_LINK_SOCIAL = 'https://elama.ru/legal_docs/event/promo-compaign-social.pdf'
export const CONSENT_LINK = 'https://elama.ru/legal_docs/pd/consent_advservice_feedback-form.pdf'
